import { SearchHit } from 'api/search';
import { SearchHitHighlightOrDocumentValue } from 'components/search/SearchHitHighlightOrDocumentValue';
import { ContactType } from 'constants/contacts';
import { Contact, Transaction } from 'types/domain';
import { NestedPath } from 'types/util';

interface ContactResult {
    hit: SearchHit<Contact>;
    resource: 'contact';
}

interface TransactionResult {
    hit: SearchHit<Omit<Transaction, 'transactions' | 'line_items'>>;
    resource: 'transaction';
}

type SearchResultContactLabelProps = ContactResult | TransactionResult;

const SearchResultContactLabel = <T,>({ hit, resource }: SearchResultContactLabelProps) => {
    const contactType = resource === 'contact' ? hit.document.type : hit.document.contact?.type;
    const prefix = resource === 'transaction' ? 'contact' : '';

    return contactType === ContactType.Company ? (
        <SearchHitHighlightOrDocumentValue
            className={'font-medium'}
            hit={hit as SearchHit<T>}
            documentKey={pathWithPrefix(prefix, 'company_name')}
        />
    ) : (
        <>
            <SearchHitHighlightOrDocumentValue
                className={'font-medium'}
                hit={hit as SearchHit<T>}
                documentKey={pathWithPrefix(prefix, 'first_name')}
            />
            <SearchHitHighlightOrDocumentValue
                className={'font-medium'}
                hit={hit as SearchHit<T>}
                documentKey={pathWithPrefix(prefix, 'last_name')}
            />
        </>
    );
};

const pathWithPrefix = <T,>(prefix: string, path: string) => {
    const combinedPath = prefix ? `${prefix}.${path}` : path;
    return combinedPath as NestedPath<T>;
};

export { SearchResultContactLabel };
